<template>
  <div class="main-view" v-if="isInited">
    <router-view></router-view>
    <TabBar :tabs="tabs" />
    <DailyCheckin v-if="showRewards" @close="showRewards = false" />
  </div>
  <div v-else class="spinner" v-loading="true">
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'

import TabBar from '@/components/TabBar.vue'

import IconPlay from '@/components/Icons/IconPlay.vue'
import IconDollar from '@/components/Icons/IconDollar.vue'
import IconFriends from '@/components/Icons/IconFriends.vue'
import IconWallet from '@/components/Icons/IconWallet.vue'
import IconLeea from '@/components/Icons/IconLeea.vue'

import { useUserStore } from '@/stores/user'
import { useTasksStore } from '@/stores/tasks'
import DailyCheckin from '@/components/DailyCheckin.vue'

const userStore = useUserStore()
const tasksStore = useTasksStore()
const showRewards = ref(false)
const isInited = ref(false)
const init = async () => {
  await userStore.triggerVisit()
  await Promise.all([userStore.fetchUser(), userStore.getFarming(), tasksStore.fetchTasks()])
  showRewards.value = !!userStore.reward
  isInited.value = true
}
init()



onBeforeMount(() => {
  window.Telegram.WebApp.expand()
  window.Telegram.WebApp.BackButton.isVisible = false
})

const tabs = [
  { icon: IconPlay, text: 'play', routeName: 'play' },
  { icon: IconFriends, text: 'friends', routeName: 'friends' },
  { icon: IconLeea, text: '', routeName: 'tap' },
  { icon: IconDollar, text: 'earn', routeName: 'earn' },
  { icon: IconWallet, text: 'wallet', routeName: 'wallet' }
]
</script>

<style lang="scss" scoped>
.spinner {
  height: 100vh;
}

.main-view {
  overflow: hidden;

  .tab-bar {
    height: 80px;
    width: 100vw;
    background-color: white;
    position: fixed;
    bottom: 0;
    left: 0;
    padding-bottom: 20px;
  }
}
</style>
